import { createContext, useContext } from 'react'

import { TreeItemIndex } from 'react-complex-tree'

import { PostType, Space } from '@bettermode/common/gql/generated'

export type SiteTreeContextType = {
  collection?: {
    showMenu?: boolean
  }
  space?: {
    to?: (space: Space) => string
  }
  cms?: {
    to?: (postType: PostType) => string
    showMenu?: boolean
  }
  /** Tree index of the space currently active in the route. */
  activeSpaceTreeIndex?: TreeItemIndex
  /** Collection the active space belongs to. */
  activeSpaceCollectionId?: string
  /** Called when a navigable tree item is selected (e.g. to close mobile sidebar). */
  onItemSelect?: () => void
}

export const SiteTreeContext = createContext<SiteTreeContextType>({})

export function SiteTreeProvider({
  children,
  value,
}: {
  children: React.ReactNode
  value: SiteTreeContextType
}) {
  return (
    <SiteTreeContext.Provider value={value}>
      {children}
    </SiteTreeContext.Provider>
  )
}

export function useSiteTreeContext() {
  const context = useContext(SiteTreeContext)
  return context
}
